export default __webpack_public_path__ + "static/summer-rect-logo-bd53e1a9d990b4a22eb6b793fca4b3ba.svg";